module.exports = __webpack_public_path__ + "img/tijiaochenggong.c3a431a1.jpg";